import Imm from '../support/ImmutableHelpers';
import DataStore from '../support/DataStore';

import { VendorSummaryWithMarkets, Vendor } from '../types/shared/Vendor';

let dataStore = DataStore.getInstance('app');

type Market = {
  id: string;
  name: string;
  dates: Array<string>;
};

let PlacementActions = {
  removeVendorPlacement(
    market: Market,
    date: string,
    placementIndex: number,
    vendor: VendorSummaryWithMarkets,
  ) {
    let vendorPlacement = dataStore.get('placement');
    if (!vendorPlacement) {
      return;
    }
    let newPlacement = Imm.setProperty(
      vendorPlacement,
      vendor.id,
      (vendorMarkets) => {
        if (!vendorMarkets) {
          return vendorMarkets;
        }
        let marketID = market.id;
        return Imm.setProperty(vendorMarkets, marketID, (vendorDates) => {
          if (!vendorDates) {
            return vendorDates;
          }
          return Imm.setProperty(vendorDates, date, (placement) => {
            if (!placement) {
              return placement;
            }
            return Imm.removeElement(placement, placementIndex);
          });
        });
      },
    );
    dataStore.set('placement', newPlacement);
  },

  removeVendorPlacementByDates(market: Market, date: string, vendor: Vendor) {
    let vendorPlacement = dataStore.get('placement');
    if (!vendorPlacement) {
      return;
    }
    let newPlacement = Imm.setProperty(
      vendorPlacement,
      vendor.id,
      (vendorMarkets) => {
        if (!vendorMarkets) {
          return vendorMarkets;
        }
        let marketID = market.id;
        return Imm.setProperty(vendorMarkets, marketID, (vendorDates) => {
          if (!vendorDates) {
            return vendorDates;
          }

          let { [date]: removedIndexes, ...otherDates } = vendorDates;

          return otherDates;
        });
      },
    );
    dataStore.set('placement', newPlacement);
  },

  addVendorPlacement(
    market: Market,
    date: string,
    placementIndex: number,
    vendor: VendorSummaryWithMarkets,
  ) {
    let vendorPlacement = dataStore.get('placement');
    if (!vendorPlacement) {
      return;
    }
    let newPlacement = Imm.setProperty(
      vendorPlacement,
      vendor.id,
      (vendorMarkets) => {
        vendorMarkets = vendorMarkets || {};
        let marketID = market.id;
        return Imm.setProperty(vendorMarkets, marketID, (vendorDates) => {
          vendorDates = vendorDates || {};
          return Imm.setProperty(vendorDates, date, (placement) => {
            placement = placement || [];
            if (~placement.indexOf(placementIndex)) {
              return placement;
            }
            placement = Imm.appendElement(placement, placementIndex);
            placement.sort();
            return placement;
          });
        });
      },
    );
    dataStore.set('placement', newPlacement);
  },
};

export default PlacementActions;
